import { render } from "./InfoCard.vue?vue&type=template&id=18886bd1"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script